import { render, staticRenderFns } from "./PortraitMenu.vue?vue&type=template&id=1b2a273d&scoped=true"
import script from "./PortraitMenu.vue?vue&type=script&lang=js"
export * from "./PortraitMenu.vue?vue&type=script&lang=js"
import style0 from "./PortraitMenu.vue?vue&type=style&index=0&id=1b2a273d&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a273d",
  null
  
)

export default component.exports